import {
  GET_GL_GROUP,
  GET_GL_GROUPS,
  ADD_GL_GROUP,
  UPDATE_GL_GROUP,
  DELETE_GL_GROUP,
  GET_GL_GROUPS_ALL,
  GET_ONE_GL_GROUP
} from '../types';

const initialState = { list: [], single: null, totalCount: 0, ledger:[] };

const reducer = (state = initialState, action) => {
  const { type, payload, totalCount } = action;

  switch (type) {
    case GET_GL_GROUPS:
      return { ...state, list: payload.data, totalCount: totalCount , pagination: payload.pagination };
    case GET_GL_GROUPS_ALL:
      return { ...state, ledger: payload, totalCount: totalCount };
    case GET_GL_GROUP:
      return { ...state, single: payload || initialState.single };

    case UPDATE_GL_GROUP:
      return {
        ...state,
        list: state.list.map((item) =>
          item.id === payload.id ? payload : item,
        ),
      };

    case ADD_GL_GROUP:
      return {
        ...state,
        list: [payload, ...state.list],
        totalCount: state.totalCount + 1
      };

    case DELETE_GL_GROUP:
      return {
        ...state,
        list: state.list.filter((item) => item.id !== payload.id),
        totalCount: state.totalCount - 1
      };

    case GET_ONE_GL_GROUP:
      return { ...state, single: payload || initialState.single };

    default:
      return state;
  }
};

export default reducer;
